import { types } from "mobx-state-tree";

export default types.model("TarotModel", {
  id: types.identifierNumber,
  image: types.maybeNull(types.string),
  rating: types.string,
  suit: types.maybeNull(types.string),
  title: "",
  meaning: types.maybeNull(types.string),
});
